export const RequiredAsterisks = () => {
  return <span className={"required-asterisks"}>*</span>;
};
